import axios from 'axios'
import { TokenService } from "./storage.service"
import store from '../store/store'

const ApiService = {
	// Stores the 401 interceptor position so that it can be later ejected when needed'
	_401interceptor: null,
	i: 0,

	init(baseURL) {
		axios.defaults.baseURL = baseURL;
	},

	setHeader() {
		axios.defaults.headers.common["Authorization"] = `Bearer ${TokenService.getToken()}`
	},

	removeHeader() {
		axios.defaults.headers.common = {}
	},

	get(resource, config = {}) {
		return axios.get(resource, config);
	},

	post(resource, data) {
		return axios.post(resource, data);
	},
	put(resource, data) {
		return axios.put(resource, data);
	},
	delete(resource) {
		return axios.delete(resource);
	},
	getFile(resource) {
		return axios.get(resource, {
			responseType: 'blob'
		})
	},

	/**
	 * Perform a custom Axios request.
	 *
	 * data is an object containing the following properties:
	 *  - method
	 *  - url
	 *  - data ... request payload
	 *  - auth (optional)
	 *    - username
	 *    - password
	 **/
	customRequest(data) {
		return axios(data);
	},
	// transformRequest: [(data, headers) => {
	//     delete headers.common.Authorization
	//     return data
	// }],
	mount401Interceptor() {
		this._401interceptor = axios.interceptors.response.use(
			(response) => {
				return response
			},
			async (error) => {
				this.i++
				if (this.i == 1) {
					if (error.request.status === 403 || error.request.status === 401) {
						await bus.$showMsgError(i18n.t('warning.tokenExpired'))
						await store.dispatch('auth/logout');
						throw error
					}
					// else if (error.request.status === 417) {
					// 	bus.$showMsgError(i18n.t('error.netAccess'))
					// 	throw error
					// }
					// else if (error.request.status == 400) {
					// 	await bus.$showMsgError(`${i18n.t('error.title')} : ${error.request.status}`)
					// 	throw error
					// }
					// else if (error.request.status === 500) {
					// 	await bus.$showMsgError(`${i18n.t('error.title')} : ${error.request.status}`)
					// 	throw error
					// }
				}
				this.i = 0
				// If error was not 401 just reject as is
				throw error
			}
		)
	},

	unmount401Interceptor() {
		// Eject the interceptor
		axios.interceptors.response.eject(this._401interceptor)
	}
};

export default ApiService;
